var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.needFooter)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.store.footBarShow),expression:"store.footBarShow"}]},[_c('div',{attrs:{"id":"iframeBox"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }